export enum WidgetDataHooks {
  MAIN_CONTAINER = 'widget-main-container',
  BLANKET = 'widget-blanket',
}
